module.exports = __webpack_public_path__ + "img/weddings_15_H.51f06775.webp";